<template>
  <omint-page>
    <TestOnline :fixed="isOffline" />
    <Header name="Credencial Offline" titleLabel="Credencial Offline" backRoute="/login" />
    <Carousel
      ref="homeCarousel"
      :perPage="1"
      :paginationPadding="0"
      :paginationColor="'#808080'"
      :paginationActiveColor="'#bcbcbc'"
      :paginationSize="8"
      :navigateTo="carouselPage"
      v-on:pageChange="carouselPageChange"
    >
      <Slide v-for="(c, idx) in credentials" :key="c.id">
        <Credential
          class="credentials"
          :id="c.id"
          :number="c.number"
          :name="c.name"
          :ingress="c.ingress"
          :valid="c.valid"
          :birth="c.birth"
          :plan="c.plan"
          :bg="c.bg"
          :credType="c.credType"
          :cns="c.cns"
          :idx="idx"
          :numberT="c.numberT"
          :planT="c.planT"
          :accT="c.accT"
          :accTp="c.accTp"
          :abrT="c.abrT"
          :cssMediaType="''"
        />
      </Slide>
    </Carousel>
    <br />
    <omt-buttons-bar v-if="!isOffline">
      <omt-button :onClick="login"> Fazer login </omt-button>
    </omt-buttons-bar>
  </omint-page>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import { mapState } from "vuex";
import Header from "@/components/Molecules/Header";
import Credential from "@/components/Organisms/Credential.vue";
import TestOnline from "@/components/Molecules/TestOnline";

export default {
  name: "OfflineCredential",
  data() {
    return {
      carouselPage: 0,
      currentOrientation: "",
      oldOrientation: "",
      isOffline: false
    };
  },
  computed: {
    ...mapState("saude", ["credentials"])
  },
  created() {
    this.isOffline = !navigator.onLine;
    window.addEventListener("offline", this.onConnectionChange);
    window.addEventListener("online", this.onConnectionChange);
    window.addEventListener("resize", this.onResizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResizeHandler);
    window.removeEventListener("offline", this.onConnectionChange);
    window.removeEventListener("online", this.onConnectionChange);
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    onConnectionChange() {
      this.isOffline = !navigator.onLine;
    },
    carouselPageChange(page) {
      const newOrientation = this.getCurrentOrientation();
      if (this.carouselPageChange > 1 || newOrientation === this.oldOrientation) {
        this.carouselPage = page;
      } else {
        if (this.$refs.homeCarousel.currentPage !== this.carouselPage) {
          this.$refs.homeCarousel.goToPage(this.carouselPage);
        }
        this.oldOrientation = this.currentOrientation;
      }
    },
    getCurrentOrientation() {
      const screenOrientation = screen.orientation || screen.mozOrientation || screen.msOrientation;
      const newOrientation = screenOrientation ? screenOrientation.type || window.orientation : window.orientation;
      return newOrientation;
    },
    onResizeHandler() {
      const newOrientation = this.getCurrentOrientation();
      if (newOrientation !== this.currentOrientation) {
        this.currentOrientation = newOrientation;
        if (this.$refs.homeCarousel.currentPage !== this.carouselPage) {
          this.$refs.homeCarousel.goToPage(this.carouselPage);
        }
      }
    }
  },
  async mounted() {
    this.isOffline = !navigator.onLine;
    this.$root.$emit("hide-loading");
    await this.onResizeHandler();
    this.currentOrientation = this.getCurrentOrientation();
    this.oldOrientation = this.currentOrientation;
  },
  components: {
    Carousel,
    Slide,
    Credential,
    TestOnline,
    Header
  }
};
</script>
<style scoped>
.credentials {
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
